import { PaddedAboutBoxBody, StyledAboutBoxContainer } from './AboutBox.styles';
import React from 'react';
export const AboutBoxContent = ({ banner, textboxSrc, textBoxContent, }) => {
    if (textBoxContent) {
        return (React.createElement(StyledAboutBoxContainer, null,
            banner,
            React.createElement(PaddedAboutBoxBody, null, textBoxContent)));
    }
    if (textboxSrc)
        return (React.createElement(StyledAboutBoxContainer, null,
            banner,
            React.createElement(PaddedAboutBoxBody, { dangerouslySetInnerHTML: { __html: textboxSrc } })));
    return React.createElement(React.Fragment, null);
};
